module.exports = __webpack_public_path__ + "img/logo.8fa9cac9.png";